import { createAsyncAction, createAction } from 'typesafe-actions';
import { IdType } from '@rootCommon/types/common';
import {
  Site, SiteDto, SiteSelector, SitesListItem,
} from '@rootCommon/types/site';
import { Filters } from '@rootCommon/types/filter';

// Site List
export const fetchSites = createAsyncAction(
  'FETCH_SITES_REQUEST',
  'FETCH_SITES_SUCCESS',
  'FETCH_SITES_FAILURE',
)<IdType | void, SitesListItem[], Error>();

export const setSitesFilter = createAction('SET_SITES_FILTER')<Filters>();

// Site
export const fetchSite = createAsyncAction(
  'FETCH_SITE_REQUEST',
  'FETCH_SITE_SUCCESS',
  'FETCH_SITE_FAILURE',
)<IdType, Site, Error>();

export const createSite = createAsyncAction(
  'CREATE_SITE_REQUEST',
  'CREATE_SITE_SUCCESS',
  'CREATE_SITE_FAILURE',
)<SiteDto, Site, Error>();

export const updateSite = createAsyncAction(
  'UPDATE_SITE_REQUEST',
  'UPDATE_SITE_SUCCESS',
  'UPDATE_SITE_FAILURE',
)<{ id: IdType; data: SiteDto }, Site, Error>();

export const deleteSite = createAsyncAction(
  'DELETE_SITE_REQUEST',
  'DELETE_SITE_SUCCESS',
  'DELETE_SITE_FAILURE',
)<IdType, IdType, Error>();

// Site Selector
export const fetchSitesSelector = createAsyncAction(
  'FETCH_SITES_SELECTOR_REQUEST',
  'FETCH_SITES_SELECTOR_SUCCESS',
  'FETCH_SITES_SELECTOR_FAILURE',
)<void, SiteSelector[], Error>();
